import React from 'react';
import { Button } from './ui/button';
import aboutBg from "../assets/images/about.jpg";

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <img
              src={aboutBg}
              alt="Unisex Beauty Salon"
              className="rounded-lg shadow-xl w-full h-[500px] object-cover"
            />
          </div>

          {/* Content */}
          <div>
            <p className="text-sm text-gray-500 uppercase tracking-wider mb-2">Experts in Field</p>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Best Unisex Beauty Salon
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Joker & Quinn is the best unisex hair salon. We offer a wide range of services to our clients including haircuts, hair styling, hair colouring and more. We are experts and provide premium services to our clients. Our motto is our client's satisfaction and we make sure they step out of our salon looking and feeling their best.
              </p>
              <p>
                The brand is well-known across the country as a leader in beauty and wellness services and is often rated as one of the top brands in the industry.
              </p>
              <p>
                Our team of stylists are professionally trained to provide you with excellent hairdressing and hair treatments and our exquisitely designed salons give you a place to unwind.
              </p>
              <p>
                We give you a luxurious and premium experience with our exclusively designed chic ambience. You will be in the hands of our expert stylists, who have specialized training and expertise.
              </p>
            </div>
            <Button
              className="mt-8 bg-black hover:bg-gray-800 text-white px-8 py-6 rounded-full transition-all duration-300"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              More About Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
